<style></style>

<template>
    <arrow-collapse class="ta-resources-section border-heavy w-100 mb-2" :visible="visible" :variant="null" :accordion="accordion">
        <template #trigger-label>
            <slot name="title"></slot>
        </template>
        <template #collapsed-content>
            <div class="p-4">
                <slot name="collapsed-content">

                </slot>
            </div>
        </template>
    </arrow-collapse>
</template>

<script>
    import ArrowCollapse from '../ArrowCollapse.vue';

    export default {
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            accordion: {
                type: String,
                default: null
            }
        },
        components: {
            ArrowCollapse
        },
        data() {
            return {}
        },
        methods: {}
    
}
</script>